// 正式
module.exports = {
  title: 'vue-h5-template',
  baseUrl: 'https://www.xxx.com/', // 正式项目地址
  // baseApi: 'http://192.168.0.3:31111', // 正式api请求地址
  baseApi: 'http://api.cqkunjing.com', // 正式api请求地址
  api: {
    base_api: 'https://xxx.xxx.com/admin',
    common_api: 'https://xxx.xxx.com/common'
  }
}
